import React, { FunctionComponent } from 'react';
import { Box, Flex, Text } from 'rebass/styled-components';
import { POLICY_EXECUTION_TABLE_COLUMN_WIDTHS } from '..';

const PolicyExecutionTableHeaders: FunctionComponent<{}> = () => (
  <Flex flexWrap="nowrap" pr={2}>
    <Box width={POLICY_EXECUTION_TABLE_COLUMN_WIDTHS[0]}>
      <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Results</Text>
    </Box>
    <Box width={POLICY_EXECUTION_TABLE_COLUMN_WIDTHS[1]}>
      <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Name</Text>
    </Box>
    <Box width={POLICY_EXECUTION_TABLE_COLUMN_WIDTHS[2]}>
      <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Condition</Text>
    </Box>
    <Box width={POLICY_EXECUTION_TABLE_COLUMN_WIDTHS[3]}>
      <Text variant="h5" sx={{ textTransform: 'uppercase' }}>Action</Text>
    </Box>
    <Box width={POLICY_EXECUTION_TABLE_COLUMN_WIDTHS[4]} />
  </Flex>
);

export default PolicyExecutionTableHeaders;
